
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PackageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Package"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"major"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"build"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bucket"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"key"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":93}};
    doc.loc.source = {"body":"fragment PackageFields on Package {\n  uuid\n  created\n  major\n  minor\n  build\n  bucket\n  key\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
